import { FARM_ENDPOINT_BY_CHAIN } from '../configs/api';
import { ERC20__factory } from '../contracts';
import { getContract } from '../utils/getContract';
export const lpListFetcher = async (chainId) => {
    const endpoint = FARM_ENDPOINT_BY_CHAIN[chainId];
    if (!endpoint)
        throw new Error('Unsupported chainId');
    const list = await (await fetch(endpoint)).json();
    const lpList = [];
    for (const lp of list) {
        try {
            lpList.push({
                ...lp,
                token: {
                    ...lp.token,
                    decimals: await getTokenDecimalsBySymbol(chainId, lp.token.address, lp.token.symbol),
                },
                quoteToken: {
                    ...lp.quoteToken,
                    decimals: await getTokenDecimalsBySymbol(chainId, lp.quoteToken.address, lp.quoteToken.symbol),
                },
            });
        }
        catch (e) {
            // ignore not ERC20
        }
    }
    return lpList;
};
const cache = {};
const getTokenDecimalsBySymbol = async (chainId, tokenAddr, symbol) => {
    symbol = symbol.toLowerCase();
    if (symbol === 'wbtc')
        return 8;
    if (symbol === 'usdt' || symbol === 'usdc')
        return 6;
    if ([
        'amply',
        'corgiai',
        'dai',
        'eth',
        'ful',
        'h2',
        'lcro',
        'mery',
        'moon',
        'veth',
        'vusd',
        'vvs',
        'ybeth',
        'ybusd',
        'zkcro',
        'zktcro',
        'wzkcro',
        'wzktcro',
    ].includes(symbol))
        return 18;
    return fetchAndCacheTokenDecimals(chainId, tokenAddr, symbol);
};
const fetchAndCacheTokenDecimals = async (chainId, tokenAddr, symbol) => {
    return (cache[symbol] ??
        (cache[symbol] = +(await getContract(chainId, tokenAddr, ERC20__factory.abi).decimals()).toString()));
};
